<template>
    <div>
        <img :style="isMobile? 'width:100%;height: auto;' : 'max-width: 500px;height: auto;'">
        <!-- Root element of PhotoSwipe. Must have class pswp. -->
        <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">

            <!-- Background of PhotoSwipe.
                It's a separate element, as animating opacity is faster than rgba(). -->
            <div class="pswp__bg"></div>

            <!-- Slides wrapper with overflow:hidden. -->
            <div class="pswp__scroll-wrap">

                <!-- Container that holds slides. PhotoSwipe keeps only 3 slides in DOM to save memory. -->
                <div class="pswp__container">
                    <!-- don't modify these 3 pswp__item elements, data is added later on -->
                    <div class="pswp__item"></div>
                    <div class="pswp__item"></div>
                    <div class="pswp__item"></div>
                </div>

                <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
                <div class="pswp__ui pswp__ui--hidden">

                    <div class="pswp__top-bar">

                        <!--  Controls are self-explanatory. Order can be changed. -->

                        <div class="pswp__counter"></div>

                        <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

                        <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

                        <!-- Preloader demo https://codepen.io/dimsemenov/pen/yyBWoR -->
                        <!-- element will get class pswp__preloader--active when preloader is running -->
                        <div class="pswp__preloader">
                            <div class="pswp__preloader__icn">
                            <div class="pswp__preloader__cut">
                                <div class="pswp__preloader__donut"></div>
                            </div>
                            </div>
                        </div>
                    </div>

                    <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                        <div class="pswp__share-tooltip"></div>
                    </div>

                    <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
                    </button>

                    <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
                    </button>

                    <div class="pswp__caption">
                        <div class="pswp__caption__center"></div>
                    </div>

                </div>

                </div>

        </div>
    </div>
</template>

<script>
import api from "@/api";
import helper from "@/vueHelper"
import PDF from "@/components/fbpdfbox";

export default {
    name: "ImageBox",
    props: {
        data: Object,
        isMobile: Boolean,
        extension: String,
        isDirectLink:Boolean
    },
    components: {
        PDF,
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            var vm = this;
            if(this.isDirectLink){
                $(vm.$el).find('img').attr('src', helper.getFile(this.data.encryption));
            }else{
                api.request(
                this,
                "post",
                "/userBuildForm/getfile",
                {
                SessionID: helper.getSessionID(),
                LocaleCode: helper.getLocaleCode(),
                Parameters: {
                    Attachment: vm.data
                }
                },
                function(r) {
                    //var photo = 'data:image/png;base64,' + r.data.file  //Base64 photo
                    var fileExtension = this.data.extension.toLowerCase();
                    var FORMAT = ['.jpeg', '.jpg', '.png', '.xls', '.xlsx', '.doc', '.docs', '.pdf'];
                    if(r.data.file){//GOT file byte from server
                        if(FORMAT.includes(fileExtension)){
                            var photos = [];
                            var photo = r.data.file;
                            photos.push(photo);
                            $(vm.$el).find('img').attr('src', 'data:image/png;base64,' + photo);
                            vm.setPhoto(photos);

                        }else if(fileExtension == '.pdf'){
                            var photos = r.data.file;
                            $(vm.$el).find('img').attr('src', 'data:image/png;base64,' + photos[0]);
                            vm.setPhoto(photos);
                        }
                    }else{//Got 0 byte from server
                        var icon = "";
                        switch(fileExtension){
                            case '.docx':
                            case '.doc':
                                icon = '<i class="fa fa-file-word fa-5x" style="padding-left: 100px;"></i>';
                            break;

                            case '.xls':
                            case '.xlsx':
                                icon = '<i class="fa fa-file-excel fa-5x" style="padding-left: 100px;"></i>';
                            break;

                            case '.ppt':
                            case '.pptx':
                               icon = '<i class="fa fa-file-powerpoint fa-5x" style="padding-left: 100px;"></i>'
                            break;
                            case '.jpeg':
                            case '.jpg':
                            case '.png':
                               icon = '<i class="fa fa-file-image fa-5x" style="padding-left: 100px;"></i>'
                            break;
                            case '.pdf':
                                icon = '<i class="fa fa-file-pdf fa-5x" style="padding-left: 100px;"></i>'
                            break;
                            default:
                                icon = '<i class="fa fa-file fa-5x" style="padding-left: 100px;"></i>'
                            break;
                        }
                        $(vm.$el).find('img').after(icon);
                    }
                },
                function(r) {
                    this.sessionErrorMsg = this.$store.state.errorMsg;
                }
            );
            }

        },
        setPhoto(photo){
            var vm = this;
            //return new Promise(resolve => { //for SAS link
                //setTimeout(() => {
                    var openPhotoSwipe = function() {
                        var pswpElement = document.querySelectorAll('.pswp')[0];
                        var items = [];
                        for(let i = 0; i < photo.length; i++){
                            var temp = new Image();
                            temp.src = 'data:image/png;base64,' + photo[i];
                            temp.onload = function(){ //NECESSARY!!
                                var width = temp.width;
                                var height = temp.height;

                                items.push({
                                    src: 'data:image/png;base64,' + photo[i],
                                    w: width,
                                    h: height
                                });
                            }
                        }

                        var options = {
                            history: false,
                            focus: false,
                            showAnimationDuration: 0,
                            hideAnimationDuration: 0

                        };
                        var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
                        setTimeout(function(){
                            gallery.init();
                        }, 50);
                    };
                    //REMINDER: If the pop up image still on the screen after closed, please check whether the click evernt render two times
                    $(vm.$el).find('img').click(function(){openPhotoSwipe()});
                //}, 250);
            //});
        }
    }
}
</script>

<style scoped>
img {
    max-width: 500px;
    height: auto;
    display:block;
    padding-top: 5px;
    padding-bottom: 5px;
}

</style>